/** DEPRECATED */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Dropdown, Icon } from '@mch-group/uikit-components'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'
import tokensRenamed from '@constants/tokensRenamed'

import { px2rem } from '@utils'
import { convertHexToRgba } from '@utils/cssHelpers'

const StyledDropdown = styled(Dropdown)`
  &&& {
    border: none;
    padding: ${px2rem(7)} 0;
    border-bottom: 1px solid ${tokens.color.light.base.neutrals['300'].value} !important;
    padding-left: 0;
    display: flex;
    justify-content: space-between;
    min-height: ${px2rem(24)} !important;

    > .text {
      margin: 0;
      line-height: ${tokensRenamed.lineHeights[6].value};
    }

    > .menu > .item {
      border-top: none;

      &.active > .text {
        &::after {
          content: '';
          width: ${px2rem(18)};
          height: ${px2rem(18)};
          margin-left: ${px2rem(6)};
          background: url("data:image/svg+xml,%3Csvg viewBox%3D'0 0 12 9' fill%3D'none' xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%3E%3Cpath d%3D'M1.5 4.13158L4.75 7.5L10.5 1.5' stroke%3D'white' stroke-width%3D'1.5'%2F%3E%3C%2Fsvg%3E") 50% center / 80% no-repeat rgb(${convertHexToRgba(tokens.color.light.base.neutrals[800].value)});
        }
      }

      .text {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &::after {
          content: '';
          width: ${px2rem(18)};
          height: ${px2rem(18)};
          border: 1px solid ${tokens.color.dark.base.neutrals[0].value};
          flex-shrink: 0;
        }
      }
    }
  }
`

const MultiSelect = ({ options, selected, itemTextKey = 'name', itemValueKey = 'id', disabledOptionCall, ariaLabel, ...others }) => {
  const [renderedOptions, setRenderedOptions] = useState([])

  useEffect(() => {
    let newOptions = []

    if (options && options.length) {
      newOptions = options.map(option => ({
        key: option[itemValueKey],
        label: option[itemTextKey],
        value: option[itemValueKey],
        active: selected.includes(option[itemValueKey]),
        disabled: disabledOptionCall && disabledOptionCall(option)
      }))
    }
    setRenderedOptions(newOptions)
  }, [options, selected, itemTextKey, itemValueKey, disabledOptionCall])

  return (
    <>
      <StyledDropdown
        // @ts-ignore
        multiple
        icon={<Icon name='chevron-down' className='icon-arrow-down' size={30} />}
        selection
        labeled={false}
        options={renderedOptions}
        selectOnBlur={false}
        value={[]}
        aria-label={ariaLabel}
        {...others}
      />
    </>
  )
}

MultiSelect.propTypes = {
  options: PropTypes.array,
  selected: PropTypes.array,
  itemTextKey: PropTypes.string,
  itemValueKey: PropTypes.string,
  disabledOptionCall: PropTypes.func
}

export default MultiSelect
